export abstract class SelectUtils {
  public static getSelectOptions(
    obj: Record<string, string>
  ): { label: string; value: string }[] {
    return Object.entries(obj)
      .map(([, label]) => ({ label, value: label }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }
}
